function cov_cewukuzw3() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/UnlockLeftFilled.tsx";
  var hash = "7aa4424640b4f656b4137de80e2c7b3b4098f8a0";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/UnlockLeftFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 58
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "7aa4424640b4f656b4137de80e2c7b3b4098f8a0"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_cewukuzw3 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_cewukuzw3();
var Icon = (cov_cewukuzw3().s[0]++, {
  name: 'unlock-left-filled',
  svg: "<path d=\"M12 1.75C9.1005 1.75 6.75 4.10051 6.75 7V7.5H9.25V7C9.25 5.48122 10.4812 4.25 12 4.25C13.5188 4.25 14.75 5.48122 14.75 7V10H5C3.89543 10 3 10.8954 3 12V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V12C21 10.8954 20.1046 10 19 10H17.25V7C17.25 4.10051 14.8995 1.75 12 1.75Z\" fill=\"currentColor\"/>"
});
export default Icon;